import React, { Component } from "react";
import { Switch } from "antd";
import {
  parseFormControlValue,
  checkEmptyObject
} from "../../../services/utils";
import styles from "./switchButton.scss";

interface SwitchButtonProps {
  data: {} | undefined;
  defaultChecked: boolean;
  field: string;
  id: string;
  isRequired: boolean;
  match: { path: string; url: string; isExact: boolean; params: {} };
  onChange: ({}) => void;
  onError: () => void;
  title: string;
  type: string;
  value: {} | undefined;
}

const SwitchButton = (props: SwitchButtonProps) => {
  const { title, isRequired } = props;

  function getValue() {
    const { value, field, defaultChecked } = props;

    if (!checkEmptyObject(value)) {
      return defaultChecked || undefined;
    }

    return value[field];
  }

  const handleChange = option => {
    const { onChange, field } = props;

    onChange(parseFormControlValue([field], [option]));
  };

  return (
    <div className={styles.switch}>
      <span
        className={`control-title ${isRequired ? "required" : ""}`}
        style={{ margin: "0" }}
      >
        {title}
      </span>
      <Switch
        className={styles.switchButton}
        checked={getValue()}
        onChange={handleChange}
      />
    </div>
  );
};

SwitchButton.defaultProps = {
  title: "",
  defaultChecked: false,
  onChange: () => null,
  isRequired: false
};

export default SwitchButton;



// WEBPACK FOOTER //
// ./src/components/FormControls/SwitchButton/SwitchButton.tsx